import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

import { Phone } from '../../Icons'
import logo from '../../../assets/logo-mini.svg'
import logoBig from '../../../assets/logo.svg'
import { Wrap, LogoContainer, IconContainer, Filler } from './styles'

class TopBar extends Component {
  openPopup() {
    this.props.onClickContact()
  }

  render() {
    return (
      <Wrap>
        <Filler />

        <LogoContainer big={this.props.logo === 'big'}>
          <Link to="/">
            {this.props.logo === 'big' ? (
              <img src={logoBig} alt="logo" width="108" height="122" />
            ) : (
              <img src={logo} alt="logo" width="35" height="35" />
            )}
          </Link>
        </LogoContainer>

        <IconContainer small onClick={this.openPopup.bind(this)}>
          <Phone size="" />
        </IconContainer>
      </Wrap>
    )
  }
}

export default withRouter(TopBar)



// WEBPACK FOOTER //
// ./src/components/MobileHeader/TopBar/index.js